import * as Request from '../../request'
import * as Constants from './constants'
import * as Common from '../common'

export const handleScheduleChange = (id: Common.ScheduleId) => ({ type: Constants.UPDATE_SCHEDULE, id })
